import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Landing from "./Landing";
import News from "./news/page.js";
import BlogList from "./blog/BlogList";
import BlogArticle from "./blog/BlogArticle";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Link } from "react-router-dom";

const ErrorPage = () => (
  <div>
    <h2>Oops! Something went wrong.</h2>
    <Link
      to="/"
      className="mt-6 inline-block px-6 py-3 bg-blue-600 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-700 transition"
    >
      Go Back Home
    </Link>
  </div>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Landing />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/blog",
    element: <BlogList />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },

  // {
  //   path: "/app",
  //   element: <App />,
  // },
]);

// Load runtime config before rendering the app
const loadRuntimeConfig = async () => {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    window._env_ = config;
  } catch (err) {
    console.error("⚠️ Failed to load runtime config:", err);
    window._env_ = {}; // fallback to empty
  }
};

loadRuntimeConfig().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>,
  );
});

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     {/* <App /> */}
//     <RouterProvider router={router} />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
